export enum UserFileType {
  AvatarPhoto = "AvatarPhoto",
  TempRefFile = "TempRefFile",
}